import type { ISODateTime } from "@inrev/common";
import { Option } from "@inrev/core";
import { Text } from "@portal/components/primitives";
import { assistantConversationTime } from "./assistantCopy";

/** Names the open conversation above its first message, with when it was last active. */
export const AdminAssistantConversationTitle = ({
	title,
	lastActivityAt,
}: {
	title: string;
	lastActivityAt: Option<ISODateTime>;
}) => (
	<div className="flex items-center gap-2" data-testid="assistant-conversation-title">
		<Text
			className="min-w-0 flex-1"
			color="secondary"
			data-testid="assistant-thread-title"
			truncate
			type="caption"
		>
			{title}
		</Text>
		{Option.isSome(lastActivityAt) && (
			<Text className="shrink-0" color="tertiary" type="caption">
				<time data-testid="assistant-conversation-time" dateTime={lastActivityAt}>
					{assistantConversationTime(lastActivityAt)}
				</time>
			</Text>
		)}
	</div>
);
